<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <SectionTemplate v-if="!loading && items.length" title="Quem Somos">
        <div
          class="d-flex flex-column mt-10"
          v-for="({ img, title, text }, keyItems) in items"
          :key="keyItems"
        >
          <div>
            <div v-if="smAndDown" class="text-h6">{{ title }}</div>

            <v-sheet
              v-if="img.length"
              :width="smAndDown ? '100%' : '40%'"
              class="float-md-left pr-7 pt-10 pt-md-0"
            >
              <GallerySlidesWidget :images="img" />
            </v-sheet>

            <div class="mt-10 mt-md-0">
              <div v-if="!smAndDown" class="text-h6">{{ title }}</div>

              <div class="ck-content" v-html="text"></div>
            </div>
          </div>
        </div>
      </SectionTemplate>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import SectionTemplate from "../templates/SectionTemplate.vue";
import GallerySlidesWidget from "../widgets/GallerySlidesWidget.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    images: [],
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      const items = [];

      this.$rest(_config.mod).list.map(({ img, title, text }) => {
        let images = [];

        if (img && img.list && img.list.length)
          img.list.map(({ path }) => {
            images.push(this.files + path);
          });

        items.push({ img: images, title, text });
      });

      return items;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    LoadingWidget,
    SectionTemplate,
    GallerySlidesWidget,
  },
};
</script>
